module.exports = "/images/authorities-icon.svg?5d364f2b5381c28a7bf6b3e62217c729";